import {
    GET_ACTIVITIES_FAIL,
    GET_ACTIVITIES_REQUEST,
    GET_ACTIVITY_LIST,
    GET_ACTIVITIES_SUCCESS,
    SET_ACTIVITIES_OPTION
} from "../constants/activitiesConstants";

const defaultActivitiesState = {
    complimentary: [],
    extra: []
};

export const getActivitiesReducer = (state = defaultActivitiesState, action) => {
    switch (action.type) {
        case GET_ACTIVITIES_REQUEST:
            return {loading: true, complimentary: [], extra: []};
        case GET_ACTIVITY_LIST:
            return {loading: true, extra: []};
        case GET_ACTIVITIES_SUCCESS:
            return {loading: false, ...action.payload};
        case GET_ACTIVITIES_FAIL:
            return {loading: false, complimentary: [], extra: [], error: action.payload};
        default:
            return state;
    }
};

export const setActivitiesOptionReducer = (state = 'all', action) => {
    switch (action.type) {
        case SET_ACTIVITIES_OPTION:
            return action.payload;
        default:
            return state;
    }
};